/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{createEditor as e}from"lexical";function t(t){const r=e(t);r._headless=!0;return["registerDecoratorListener","registerRootListener","registerMutationListener","getRootElement","setRootElement","getElementByKey","focus","blur"].forEach((e=>{r[e]=()=>{throw new Error(`${e} is not supported in headless mode`)}})),r}export{t as createHeadlessEditor};
